var waitFor = require("./utils/waitFor");

window.TRAINING_EVENTS = {
  NEW_MODULE: "NEW_MODULE",
  NEXT_MODULE: "NEXT_MODULE",
  PREV_MODULE: "PREV_MODULE",
  GOTO_MODULE: "GOTO_MODULE",
};

// debug events
$.each(TRAINING_EVENTS, function (i, eventName) {
  $(".positronic-app.training").on(
    TRAINING_EVENTS[eventName],
    function (e, args) {
      console.log(TRAINING_EVENTS[eventName], args);
    }
  );
});

waitFor("body.single-training-lesson", function () {
  require("./training/scroll.js");
  require("./training/navBar.js");
  require("./training/userTracking.js");
  require("./training/quiz.js");
});
